import '@/styles/index.scss'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './icons'
import SvgIcon from '@/components/SvgIcon'
import injectFilters from "@/utils/filter";
import installPlugins from '@/plugins'

/* todo - instance */
const app = createApp(App)

app.component('SvgIcon', SvgIcon)
injectFilters(app)
// install plugins
installPlugins(app)

/* todo - mock module */
if (process.env.NODE_ENV === 'local') {
  const { mockServer } = require('../mock/mock-server')
  mockServer()
}

app
  .use(store)
  .use(router)
  .mount('#app')
